var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCg = function SvgCg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-79.458 32h640v480h-640z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(79.458 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M-119.46 32h720v480h-720z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.46 32v480l480-480h-480z",
    fill: "#00ca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54 512h480V32l-480 480z",
    fill: "red"
  }))));
};
export default __webpack_public_path__ + "assets/e0101aac115dab96894258ebf4202c87.svg";
export { SvgCg as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cg.svg